import React, { useEffect } from 'react';

export default function Notice({ active = true, message = '26년에 만나요!' }) {
  useEffect(() => {
    if (!active) return;

    const preventNav = e => {
      const el = e.target.closest('a, button');
      if (el) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    document.addEventListener('click', preventNav, true);

    return () => {
      document.removeEventListener('click', preventNav, true);
    };
  }, [active]);

  if (!active) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black/60 backdrop-blur-sm text-center">
      <div className="bg-white/90 dark:bg-gray-900/90 px-8 py-10 rounded-2xl shadow-xl">
        <h1 className="text-4xl font-extrabold mb-4">{message}</h1>
        <p className="text-gray-600 dark:text-gray-300">
          생카데이는 잠시 공사 중입니다.
          <br />
          26년에 다시 만나요 ☕
        </p>
      </div>
    </div>
  );
}
